import { useLocation, BrowserRouter, Routes, Route } from 'react-router-dom';
import '@/App.css';
import { AuthProvider, useAuth } from '@/lib/auth';
import Landing from '@/pages/Landing';
import AppShell from '@/pages/AppShell';
import ProtectedRoute from '@/pages/ProtectedRoute';
import Dashboard from '@/pages/Dashboard';
import CreateAndPost from '@/pages/CreateAndPost';
import Scheduler from '@/pages/Scheduler';
import PublishingHistory from '@/pages/PublishingHistory';
import Ads from '@/pages/Ads';
import Marketplace from '@/pages/Marketplace';
import CuratorInbox from '@/pages/CuratorInbox';
import CuratorRegister from '@/pages/CuratorRegister';
import Credits from '@/pages/Credits';
import Connections from '@/pages/Connections';
import Profile from '@/pages/Profile';
import PublicProfile from '@/pages/PublicProfile';
import AIChat from '@/pages/AIChat';
import Labels from '@/pages/Labels';
import LabelPortal from '@/pages/LabelPortal';
import CreativeStudio from '@/pages/CreativeStudio';
import SpotifyCallback from '@/pages/SpotifyCallback';
import LabelVerify from '@/pages/LabelVerify';
import SocialCallback from '@/pages/SocialCallback';
import PrivacyPolicy from '@/pages/PrivacyPolicy';
import DataDeletion from '@/pages/DataDeletion';
import ConsentBanner from '@/components/ConsentBanner';
import Terms from '@/pages/Terms';
import PaymentSuccess from '@/pages/PaymentSuccess';
import PaymentCancel from '@/pages/PaymentCancel';
import Login from '@/pages/Login';
import Register from '@/pages/Register';
import VerifyEmail from '@/pages/VerifyEmail';
import ForgotPassword from '@/pages/ForgotPassword';
import ResetPassword from '@/pages/ResetPassword';

function AppRouter() {
  const location = useLocation();

  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/spotify/callback" element={<SpotifyCallback />} />
      <Route path="/label-verify" element={<LabelVerify />} />
      <Route path="/twitter/callback" element={<SocialCallback provider="twitter" />} />
      <Route path="/meta/callback" element={<SocialCallback provider="meta" />} />
      <Route path="/meta-ads/callback" element={<SocialCallback provider="meta_ads" />} />
      <Route path="/tiktok/callback" element={<SocialCallback provider="tiktok" />} />
      <Route path="/tiktok-ads/callback" element={<SocialCallback provider="tiktok_ads" />} />
      <Route path="/google/callback" element={<SocialCallback provider="google" />} />
      <Route path="/google-ads/callback" element={<SocialCallback provider="google_ads" />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/profile/:userId" element={<PublicProfile />} />
      <Route path="/data-deletion" element={<DataDeletion />} />
      <Route path="/terms" element={<Terms />} />
      <Route element={<ProtectedRoute><AppShell /></ProtectedRoute>}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/create" element={<CreateAndPost />} />
        <Route path="/chat" element={<AIChat />} />
        <Route path="/scheduler" element={<Scheduler />} />
        <Route path="/publishing-history" element={<PublishingHistory />} />
        <Route path="/ads" element={<Ads />} />
        <Route path="/marketplace" element={<Marketplace />} />
        <Route path="/labels" element={<Labels />} />
        <Route path="/label-portal" element={<LabelPortal />} />
        <Route path="/creative" element={<CreativeStudio />} />
        <Route path="/inbox" element={<CuratorInbox />} />
        <Route path="/curator" element={<CuratorRegister />} />
        <Route path="/connections" element={<Connections />} />
        <Route path="/credits" element={<Credits />} />
        <Route path="/profile" element={<Profile />} />
      </Route>
    </Routes>
  );
}

function AuthenticatedConsentBanner() {
  const { user, loading } = useAuth();

  if (loading || !user) return null;

  return <ConsentBanner />;
}

export default function App() {
  return (
    <div className="App dark">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <AuthenticatedConsentBanner />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
